export const MAIL_CONDITIONAL_FORMATTING_SETTING_NAME = 'mail_conditionalformatting';
export const CALENDAR_CONDITIONAL_FORMATTING_SETTING_NAME = 'calendar_conditionalformatting';
